import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { WORKSPACE_VERSION } from '@/api/workspace';
import type { SharedTab } from '@/domain/SharedTab.ts';

export function shareTabMutation(builder: WebapiEndpointBuilder) {
  return builder.mutation<void, SharedTab>({
    query: (body) => ({
      url: `/userdata/workspace/shared/${body.tabId}/${WORKSPACE_VERSION}`,
      method: 'POST',
      body,
    }),
  });
}
